import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const activityContactRelationDataClassName =
  DataClassName.ACTIVITY_CONTACT_RELATION
const activityContactRelationEndpoint = PisaDataClassEndpoint.ACTIVITY_CONTACT

export function pisaActivityContactRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(activityContactRelationDataClassName, {
    title: activityContactRelationDataClassName,
    restApi: createPisaRestApiConfig(activityContactRelationEndpoint),
    attributes,
  })
}
